import { CreateCustomField } from 'modals/CustomFieldCreateModal/views/CreateCustomFieldView/CreateCustomField';
import { QuerySwitch } from 'components/QuerySwitch';
import { FetchCustomFieldsDataContext } from 'pages/Settings/pages/CustomFields/contexts/FetchCustomFields.data.context';
import { FC } from 'react';

export const CreateCustomFieldView: FC = () => {
  return <QuerySwitch context={FetchCustomFieldsDataContext} component={CreateCustomField} />;
};
